export const indexedGuard = (_, event, meta) => 'index' in event && event.index === meta.cond.index;
